import router from "@/router";
import store from "@/stores";
import Ajax from "@/utils/DuduAjax";
import { API_BIS_PROJECT } from "@/configs/Apis";

router.beforeEach((to, from, next) => {
  let pending = Promise.resolve();
  const project = (store.state as any).project;
  let projectId = to.query.id;

  if (project.info === null || project.info === undefined) {
    const foundRouters = to.matched.filter(r => (r.meta.inProject as any) === true);// 是否需要加载项目数据
    if (foundRouters.length) {
      // 项目ID为空，尝试在路由配置中寻找项目ID
      if (!projectId) {
        const mainRouter = foundRouters.find(r => Object.prototype.hasOwnProperty.call(r.meta, "projectId"));
        if (mainRouter) {
          projectId = mainRouter.meta.projectId;
        }
      }
      if (projectId) {
        pending = Ajax.get<Array<any>>({ url: API_BIS_PROJECT, path: { id: projectId } }).then((data) => {
          let pending = Promise.resolve();
          if (data) {
            pending = store.dispatch("project/setProjectInfo", data);
          }
          return pending;
        });
      }
    }
  }
  pending.then(() => {
    next();
  }).catch((error) => {
    console.info(error);
  });
});
